import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';
import { Link, Navigate, useParams } from 'react-router-dom';
import { IconWithLabelDisplay } from '../../components/iconWithLabelDisplay';
import { ALL_GAME_GUIDE_PAGES, DEFAULT_GAME_GUIDE_PAGE } from '../../gameGuide/gameGuidePages';
import { isGameGuidePageType } from '../../types/gameGuideTypes';
import { SubPageContainer } from '../components/subPageContainer';
export const GameGuidePage = () => {
    let { guidePageType } = useParams();
    if (guidePageType === DEFAULT_GAME_GUIDE_PAGE) {
        // Don't allow showing of the default page under '/guide/___', show it at '/guide':
        return _jsx(Navigate, { to: '/guide' });
    }
    if (!guidePageType) {
        guidePageType = DEFAULT_GAME_GUIDE_PAGE;
    }
    if (!isGameGuidePageType(guidePageType)) {
        // not a recognized page, show the default page:
        return _jsx(Navigate, { to: '/guide' });
    }
    const { title, content } = ALL_GAME_GUIDE_PAGES[guidePageType];
    return (_jsxs(SubPageContainer, { title: guidePageType === DEFAULT_GAME_GUIDE_PAGE ? title : `Game Guide: ${title}`, children: [content, guidePageType !== DEFAULT_GAME_GUIDE_PAGE && (_jsx("div", { css: css `
            padding-top: 30px;
          `, children: _jsx(Link, { to: '/guide', children: _jsx(IconWithLabelDisplay, { icon: _jsx(ArrowBackRoundedIcon, {}), label: 'Game Guide Home', isInline: true }) }) }))] }));
};
